import { render, staticRenderFns } from "./Guild.vue?vue&type=template&id=f882f9d4&lang=pug"
import script from "./Guild.vue?vue&type=script&lang=js"
export * from "./Guild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports